// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-area[data-v-325f2a47]{flex-grow:1;border-radius:6px;padding-left:12px;height:30px;background:var(--m-color-gray-200);color:var(--m-color-text-primary)}.input-area[data-v-325f2a47]::-webkit-input-placeholder{color:var(--m-color-gray-600)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
